import { Drawer, PaperProps, useTheme } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../assets/icons/Close.svg';
import {
  SIDE_PANEL_WIDTH,
  SidePanelCloseButton,
  SidePanelContainer,
  SidePanelFooter,
  SidePanelHeader,
  SidePanelScrollArea,
  SidePanelSubtitle,
  SidePanelTitle,
} from './styles';
import { UPSidePanelProps } from './types';

/**
 * Right-hand side panel shared by configuration screens. It is the drawer pattern of
 * ContractDetailPanel, extracted without that screen's contents.
 */
const UPSidePanel = (props: UPSidePanelProps): JSX.Element => {
  const { open, title, subtitle, onClose, footer, children, width, testId } = props;
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={open}
      variant="temporary"
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        onClose();
      }}
      ModalProps={{ keepMounted: false }}
      PaperProps={
        {
          'data-testid': testId,
          sx: { width, maxWidth: '100vw', backgroundColor: theme.palette.info.light },
        } as PaperProps
      }
    >
      <SidePanelContainer>
        <SidePanelHeader>
          <div>
            <SidePanelTitle>{title}</SidePanelTitle>
            {subtitle && <SidePanelSubtitle>{subtitle}</SidePanelSubtitle>}
          </div>
          <SidePanelCloseButton type="button" aria-label="close" onClick={onClose}>
            <CloseIcon fill={theme.palette.secondary.contrastText} />
          </SidePanelCloseButton>
        </SidePanelHeader>
        <SidePanelScrollArea>{children}</SidePanelScrollArea>
        {footer && <SidePanelFooter>{footer}</SidePanelFooter>}
      </SidePanelContainer>
    </Drawer>
  );
};

UPSidePanel.defaultProps = {
  subtitle: undefined,
  footer: undefined,
  width: SIDE_PANEL_WIDTH,
  testId: undefined,
};

export default UPSidePanel;
